import { Api } from '@monorepo/shared/apiClient';
import {
  AnalyticsSyncCacheEvents,
  invalidateAnalyticsSyncCache,
} from '@monorepo/shared/cacheRegisters/data2/analyticsSyncCacheRegister';
import { clearCache as clearAnalyticsSyncCache } from '@monorepo/shared/hooks/analyticsSync/useAnalyticsSync';
import { MutationConfig, useMutation } from 'react-query';

type useAnalyticsSyncDeleteParams = {
  config?: MutationConfig<Api.DeleteAnalyticsSyncResponse, Api.ErrorResponse>;
};

export const useAnalyticsSyncDelete = (params?: useAnalyticsSyncDeleteParams) =>
  useMutation(Api.deleteAnalyticsSync, {
    ...params?.config,
    onSuccess: (deleteResponse, mutationFuncParams) => {
      const { organizationId } = mutationFuncParams;
      const keyParams = {
        organizationId,
        inputDatasetId: deleteResponse.inputDatasetId,
      };

      // Clearing cache for that single AnalyticsSync
      clearAnalyticsSyncCache(keyParams);
      invalidateAnalyticsSyncCache(AnalyticsSyncCacheEvents.DELETE, keyParams);

      return params?.config?.onSuccess?.(deleteResponse, mutationFuncParams);
    },
  });
